import { Action } from './Action.js';
import { Converter } from '../observer/converter.js';

/**
 * @class SetParameterValue
 * @extends Action
 * @classdesc Действие Установить параметр
 * Установить значение из источника в приемник
 * */
export class SetParameterValue extends Action {
    execute(context) {
        for (let link in this.prop_link) {
            let value = this.calcParam(this.Source.value, context);
            const opt = this.Operation ? { Operation: this.Operation } : null;
            if (this.Source.type !== this.Target.type) {
                value = Converter.convert({ DataType: this.Target.type }, value, this.Source.type);
            }
            this.prop_link[link](value, null, null, opt, true);
        }
    }

    get Operation() {
        return this._Operation || 0;
    }
    set Operation(v) {
        this._Operation = window._enums.HMIOperation[v];
    }
}